'use client';

import { UserRole, UserType } from '@baseball-near-you/common';
import { Button } from '@baseball-near-you/ui';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';

export function SuccessStep(props: {
  onStepSuccess: () => Promise<void>;
}) {
  const { userProfile } = useUserProfile();
  return (
    <div>
      <p className="mb-3 font-semibold text-gray-800 text-xl">
        You're all set up.
      </p>
      <p>
        {userProfile?.type === UserType.Personal
          ? `Now you can browse all teams freely, leave reviews for organizations ${
              userProfile.role === UserRole.Athlete
                ? "you've"
                : 'your athlete has'
            } played for, and contact organizations!`
          : (userProfile?.claims ?? []).length > 0
            ? 'Once we review your claim, you will be able to further customize your team and manage contact requests from players!'
            : 'Find your team and claim it, or create your own to get started!'}
      </p>
      <Button
        className="mt-8 w-full bg-red"
        onClick={() => {
          props.onStepSuccess();
        }}
      >
        Continue
      </Button>
    </div>
  );
}
